import Component from '@glimmer/component';

interface Args {
	text: string;
}

export default class BlockContentTableCompareLabelComponent extends Component<Args> {
	// custom dr takes up 22 and we don't want to shorten that (`vs xx/xx/xx - xx/xx/xx`)
	maxLength = 22;

	get isShortened() {
		return this.args.text.length > this.maxLength + 1;
	}

	get shownText() {
		let text = this.args.text;
		if (this.isShortened) {
			text = text.substring(0, this.maxLength) + '…';
		}
		return text;
	}

	get tooltipText() {
		return this.isShortened ? this.args.text : '';
	}
	<template>
		<span class="bc__label" title={{this.tooltipText}}>{{this.shownText}}</span>
	</template>
}
